module.exports = __webpack_public_path__ + "img/heater.c5731931.svg";